import React from "react";
import jwtAuthAxios from "app/services/auth/jwtAuth";




// Function to build the tree structure
export function buildMenuTree(data, parentCode = 0) {
  const tree = [];

  data.forEach((item) => {
    if (item.FL_PARENT_MENU_CODE === parentCode) {
      const hasChildren = data.some((childItem) => childItem.FL_PARENT_MENU_CODE === item.FL_MENU_CODE);

      const node = {
        label: item.FL_MENU_NAME,
        uri: item.FL_SLUG,
        icon: item.FL_SYGICONE,
        children: hasChildren ? buildMenuTree(data, item.FL_MENU_CODE) : undefined, // Recursive call for children
        type: hasChildren ? "collapsible" : "nav-item", // Set type to "collapsible" if has children
        // Add other properties as needed
      };

      tree.push(node);
    }
  });

  return tree;
}


// Call the buildMenuTree function with your input data
// const menuTree = buildMenuTree(inputData);

// console.log(menuTree);

const menus = async () => {
  const { data } = await jwtAuthAxios.get('user/userMenu')
  let ResData = data?.data?.map((item) => ({
    uri: item.FL_MODULE_CODE,
    view: item.FL_VIEW_ALLOWED,
    menu:item.FL_MENU,
    insert: item.FL_INSERT_ALLOWED,
    edit: item.FL_UPDATE_ALLOWED,
    delete: item.FL_DELETE_ALLOWED,
    export: item.FL_EXPORT_ALLOWED,
    print: item.FL_PRINT_ALLOWED,
  }))
  let treeData= await buildMenuTree(data?.data?.filter(m=>m.FL_MENU == 1))
  return {Gaurd:ResData,Menu:treeData,curr:data?.Curcode}
}
export default menus;
